module.exports = __webpack_public_path__ + "static/media/carousel1.6803cfc9.jpeg";